<template>
    <component :is="control ? 'LControl' : 'div'" position="topleft">
        <b-button id="tooltipprovider" 
            class="shadow-lg" 
            variant="dark"
            href="#" tabindex="0"
        >
            <img src="../assets/interface/layers.svg"
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)" 
            />
        </b-button>
        <b-tooltip placement="rightbottom" :show.sync="show" target="tooltipprovider" variant="light" triggers="focus">
            <b-list-group flush class="my-n1 mx-n2" style="font-size:1.1em">
                <b-list-group-item v-for="(provider, index) in tileProviders" 
                    class="text-left"
                    variant="dark" 
                    :style="index == 0 ? 'border-top-right-radius:4px;border-top-left-radius:4px;height:4em' : 
                        index+1 == tileProviders.length ? 'border-bottom-right-radius:4px;border-bottom-left-radius:4px;height:4em' : 'height:4em'" 
                    :key="index" 
                    button 
                    :active="value === provider"
                    @click="$emit('input', provider);show = false"
                >
                    <img 
                        :src="provider.icon" 
                        class="mr-1" :style="value === provider && tileProviders.length != index + 1 ? 'filter:invert(0.5)' : ''"
                        :width="tileProviders.length == index + 1 ? '30em' : '45em'" 
                        :height="tileProviders.length == index + 1 ? '30em' : '45em'"/>
                    <span class="text-center">{{ provider.name }}</span>
                </b-list-group-item>
            </b-list-group>
        </b-tooltip>
    </component>
</template>

<script>
import { tileProviders } from '../config'
import { LControl } from 'vue2-leaflet'
import { setCookie, getCookie } from '../tools'
import { BListGroup, BListGroupItem, BTooltip } from "bootstrap-vue"
export default {
    name: "UebersichtControlProvider",
    components: {
        LControl,
        BListGroup, 
        BListGroupItem,
        BTooltip
    },
    data(){
        return {
            show: false
        }
    },
    watch:{
        value: function(){
            var index = this.tileProviders.findIndex(x => x.name == this.value.name)
            var cookie = {
                exdays: this.darkmode,
                name: "bszwmProvider",
                value: index,
            }
            setCookie(cookie)
        }
    },
    computed:{
        tileProviders: () => tileProviders
    },
    props: {
        value: {},
        control: Boolean
    },
    mounted(){
        var providerIndex = getCookie("bszwmProvider")
        if(providerIndex != undefined)
            this.$emit('input', tileProviders[providerIndex])
    }
}
</script>